import pickBy from 'lodash/pickBy'

export default (obj, exception) => {
  const emptyKeys = Object.keys(pickBy(obj, val => !val && typeof val !== 'boolean'))

  if (!exception) {
    return emptyKeys.length === 0
  }
  return emptyKeys.filter(ek => exception.indexOf(ek) === -1).length === 0
}
